import React from "react";
import './send-message-box.styles.css'

export default function SendMessageBox() {
    return (
        <div className="send-message-container">
            <div className="send-message-manager">
                <div className="send-message-content" id="smbContent">
                    <div className="text-content-container">
                        <div className="text-content">
                            <div className="close-button">
                                <i className="remove blue icon" id="smbBlueIcon"></i>
                            </div>
                            <div className="text-message">
                                <div className="ui blue header font-weight-bold">
                                    Have a Question ?
                                </div>
                                <div className="ui small header no-margin">
                                    Ask about our products, services, or latest research. Let's discuss how we can help you solve your problem.
                                </div>
                                <div id="smbEmptyDiv"></div>
                                <div id="smbLinkDiv">
                                    <a href="https://www.cctech.co.in/contact-us#send-a-message">
                                        <div className="svg-button svg-blue-button" id="smbBlueButton">
                                            <svg height="40" width="196" xmlns="http://www.w3.org/2000/svg">
                                                <rect height="100%" width="100%" className="svg-button-background"></rect>
                                                <rect height="100%" width="21%" x="79%" className="svg-button-icon-background"></rect>
                                                <g>
                                                    <text className="svg-button-text" x="20" y="65%">Send a Message</text>
                                                </g>
                                                <g>
                                                    <text className="svg-button-icon" x="86%" y="65%">&#xf1d8;</text>
                                                </g>
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <img className="text-message-bubble-tail" src="https://static.cctech.co.in/prod/images/send-message/send-message-box-tail.svg" alt="Message Box Tail"></img>
                        </div>
                    </div>
                </div>
                <div className="send-message-button">
                    <div className="message-icon">
                        <img className="ui image" src="https://static.cctech.co.in/prod/images/send-message/send-message-icon.svg" alt="Message Icon"></img>
                    </div>
                </div>
            </div>
        </div>
    )
}